import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initSentry } from "./lib/sentry-init";
import "./index.css";

// Story 1.8: initialize Sentry BEFORE React mount so any render-time error
// is captured. No-op when VITE_SENTRY_DSN is unset (dev default).
initSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
